import React from 'react';
import { validateUpdateServiceDetails } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Redirect } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    MenuItem,
    Button,
    CircularProgress,
    TextField,
    Select,
    FormControl,
    InputLabel,
    FormHelperText
} from '@material-ui/core';
import ReactCrop from 'react-image-crop';
import Dropzone from 'react-dropzone';
import 'react-image-crop/dist/ReactCrop.css';
import MultiAddressPanel from './MultiAddressPanel';
import { ROLE_CUSTOMER } from '../../utils/config/constants';

// const packagePacket = {
//     name: '',
//     nameError: '',
//     description: '',
//     descriptionError: '',
//     costPrice: '',
//     costPriceError: '',
//     price: '',
//     priceError: ''
// };
const handleDropRejected = (...args) =>
    NotificationManager.error(
        <FormattedMessage
            id="errorUploading"
            defaultMessage="Unable to upload this picture, try another"
        />,
        'Error'
    );
const styles = {
    width: '100%',
    height: '100%',
    formControl: {
        minWidth: '100%',
        margin: '0'
    }
};
class ServiceUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            category: props.data ? props.data.category.key : '',
            categoryError: '',
            service: props.data ? props.data.serviceId : '',
            serviceError: '',
            loaderButton: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            type_id: 1,
            selectedAddresses: props.data ? props.data.address_ids : [],
            serviceData: [],
            showAddOwnSection: props.data.isCustom
                ? props.data.isCustom
                : false,
            name: props.data.isCustom ? props.data.name : '',
            nameError: '',
            description: props.data ? props.data.description : '',
            descriptionError: '',
            price: props.data ? props.data.price : '',
            priceError: '',
            validate: true,
            addAddress: false,
            addressError: '',
            displayAddress: props.userData.addresses.filter(
                address => address.is_default === 1
            )[0],
            packages: [],
            faq: [],
            proServiceId: props.data.key,
            status: props.data ? props.data.status : 1,
            statusError: '',
            redirect: false,
            crop: {
                aspect: 1 / 1
            },
            costPriceError: '',
            costPrice: props.data ? props.data.costPrice : '',
            existingImage: '',
            files: [],
            showOld: true,
            serviceImage: props.data ? props.data.service.image.small : ''
        };
    }

    submit = async () => {
        const {
            name,
            description,
            price,
            selectedAddresses,
            category,
            service,
            showAddOwnSection
        } = this.state;

        const result = await validateUpdateServiceDetails(
            {
                selectedAddresses,
                name,
                description,
                price,
                category,
                service,
                showAddOwnSection
            },
            this.handleError
        );

        if (result) {
            this.addService();
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Error'
            );
        }
    };

    componentDidMount() {
        if (this.props.data) {
            this.getServices(this.props.data.category.key);
        }
    }

    addService = () => {
        this.setState({ loader: true });
        const {
            selectedAddresses,
            name,
            description,
            price,
            category,
            service,
            proServiceId,
            status
        } = this.state;
        this.props.updateProviderServiceAction(
            {
                proServiceId: proServiceId,
                serviceName: name,
                serviceId: service,
                categoryId: category,
                addressIds: selectedAddresses,
                hourlyPrice: parseInt(price),
                description: description,
                faq: [],
                status: status,
                image: this.state.croppedImageUrl
            },
            this.onUpdateDone
        );
    };
    handleError = params => {
        this.setState(params);
    };

    onUpdateDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.setState({ redirect: true });
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };
    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress />;
        }
        return (
            <Button
                variant="raised"
                color="primary"
                className="jr-btn"
                onClick={this.submit}
            >
                Update
            </Button>
        );
    };
    getServices = catId => {
        const services = this.props.categoryData.find(cat => cat.key === catId);
        this.setState({ serviceData: services.services });
    };

    handleCategoryChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            categoryError: ''
        });
        this.getServices(event.target.value);
    };
    handleServiceChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            serviceError: ''
        });
    };
    handleStatusChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            statusError: ''
        });
    };

    addYourOwnItem = () => {
        this.setState({ showAddOwnSection: true, serviceError: '' });
    };
    setAddress = keys => {
        this.setState({ selectedAddresses: keys, addressError: '' });
    };
    closeAddressPopup = () => {
        this.setState({ addAddress: false });
    };

    addNewItem = () => {
        this.setState(
            prevState => ({
                packages: [
                    ...prevState.packages,
                    {
                        name: '',
                        nameError: '',
                        description: '',
                        descriptionError: '',
                        costPrice: '',
                        costPriceError: '',
                        price: '',
                        priceError: ''
                    }
                ]
            }),
            () => console.log(this.state.packages)
        );
    };
    removeItem = index => {
        let newPackages = [...this.state.packages];
        newPackages.splice(index, 1);
        this.setState({ packages: newPackages });
    };

    addNewFAQItem = () => {
        this.setState(
            prevState => ({
                faqs: [
                    ...prevState.faqs,
                    {
                        question: '',
                        questionError: '',
                        answer: '',
                        answerError: ''
                    }
                ]
            }),
            () => console.log(this.state.faqs)
        );
    };
    removeFAQItem = index => {
        let newFaqs = this.state.faqs;
        newFaqs.splice(index, 1);
        this.setState({ faqs: newFaqs });
    };

    handleDrop(files) {
        this.setState({
            files: files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ),
            showOld: false
        });
    }

    onImageLoaded = (image, pixelCrop) => {
        this.imageRef = image;
    };
    onCropComplete = async (crop, pixelCrop) => {
        if (crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                pixelCrop,
                'newFile.jpeg'
            );
            this.setState({ croppedImageUrl });
        }
    };

    getCroppedImg(image, pixelCrop, fileName) {
        const canvas = document.createElement('canvas');

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        return new Promise((resolve, reject) => {
            this.fileUrl = canvas.toDataURL('image/jpeg');
            resolve(this.fileUrl);
        });
    }
    render() {
        const thumbs = this.state.files.map((file, index) => (
            <div key={index}>
                <h5>
                    <FormattedMessage
                        id="customer.originalimage"
                        defaultMessage="Original Image"
                    />
                </h5>
                <ReactCrop
                    src={file.preview}
                    imageStyle={{
                        maxHeight: '100%'
                    }}
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    crop={this.state.crop}
                    onChange={crop => {
                        this.setState({ crop });
                    }}
                />
            </div>
        ));
        const {
            serviceData,
            name,
            nameError,
            description,
            descriptionError,
            price,
            priceError,
            loaderButton,
            addressError,
            categoryError,
            serviceError,
            statusError,
            redirect,
            showOld,
            croppedImageUrl,
            costPriceError,
            costPrice,
            serviceImage
        } = this.state;
        const { classes } = this.props;
        const { formatMessage } = this.props.intl;
        if (redirect) {
            return <Redirect to={`/provider/service`} />;
        }
        return (
            <div className="hom-cre-acc-left hom-cre-acc-right">
                <form
                    className="form-new"
                    noValidate
                    autoComplete="off"
                    id="service-create"
                >
                    <div className="row">
                        <div className="col-md-6 col-xs-12">
                            <FormControl
                                className={
                                    classes.formControl +
                                    ' login-form-textfield mt-15'
                                }
                                error={categoryError ? true : false}
                            >
                                <InputLabel shrink>Category</InputLabel>
                                <Select
                                    className="login-form-textfield  form-control"
                                    autoWidth={true}
                                    value={this.state.category}
                                    onChange={this.handleCategoryChange}
                                    inputProps={{
                                        name: 'category'
                                    }}
                                >
                                    {this.props.categoryData.map(
                                        (cat, index) => {
                                            return (
                                                <MenuItem
                                                    value={cat.key}
                                                    key={index}
                                                >
                                                    {cat.heading}
                                                </MenuItem>
                                            );
                                        }
                                    )}
                                </Select>
                                <FormHelperText>{categoryError}</FormHelperText>
                            </FormControl>
                        </div>
                        {!this.state.showAddOwnSection && (
                            <div className="col-md-6 col-xs-12">
                                <FormControl
                                    className={
                                        classes.formControl +
                                        ' login-form-textfield mt-15'
                                    }
                                    error={serviceError ? true : false}
                                >
                                    <InputLabel shrink>Service</InputLabel>
                                    <Select
                                        className="login-form-textfield  form-control"
                                        autoWidth={true}
                                        value={this.state.service}
                                        onChange={this.handleServiceChange}
                                        inputProps={{
                                            name: 'service'
                                        }}
                                    >
                                        {serviceData &&
                                            this.state.serviceData.map(
                                                (service, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={service.key}
                                                        >
                                                            {service.heading}
                                                        </MenuItem>
                                                    );
                                                }
                                            )}
                                    </Select>
                                    <FormHelperText>
                                        {serviceError}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        )}
                        {this.state.showAddOwnSection && (
                            <React.Fragment>
                                <div className="row update-profile-drop col-md-12">
                                    {showOld && (
                                        <div className="col-md-4">
                                            {serviceImage != '' && (
                                                <div>
                                                    <h5>
                                                        <FormattedMessage
                                                            id="customer.existingimage"
                                                            defaultMessage="Existing Image"
                                                        />
                                                    </h5>
                                                    <img
                                                        alt="existingImage"
                                                        src={serviceImage}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className="col-md-4">
                                        <h5>
                                            <FormattedMessage
                                                id="customer.drop"
                                                defaultMessage="Drop Image here to Upload"
                                            />
                                        </h5>
                                        <div className="drop-box">
                                            <Dropzone
                                                onDrop={this.handleDrop.bind(
                                                    this
                                                )}
                                                accept="image/jpeg,image/jpg,image/png"
                                                multiple={false}
                                                maxSize={2097152}
                                                onDropRejected={
                                                    handleDropRejected
                                                }
                                            >
                                                {({
                                                    getRootProps,
                                                    getInputProps
                                                }) => (
                                                    <div {...getRootProps()}>
                                                        <input
                                                            {...getInputProps()}
                                                        />
                                                        <p>
                                                            <FormattedMessage
                                                                id="customer.dropfiles"
                                                                defaultMessage="Drop files here, or click to select files"
                                                            />
                                                        </p>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </div>
                                    </div>
                                    {thumbs.length > 0 && (
                                        <div className="col-md-4">{thumbs}</div>
                                    )}
                                    <div className="col-md-4">
                                        {croppedImageUrl && (
                                            <div>
                                                <h5>
                                                    <FormattedMessage
                                                        id="customer.finalimage"
                                                        defaultMessage="Final Image"
                                                    />
                                                </h5>
                                                <img
                                                    alt="Crop"
                                                    src={croppedImageUrl}
                                                />
                                            </div>
                                        )}
                                    </div>

                            
                    <div className="col-sm-12">
                      <p>Please make sure that the image dimensions are atleast 1200px x 1200px</p>
                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <TextField
                                        error={nameError ? true : false}
                                        helperText={nameError}
                                        type="text"
                                        name="name"
                                        className="login-form-textfield"
                                        label="Name"
                                        id="name"
                                        fullWidth
                                        placeholder="Add Name"
                                        margin="normal"
                                        onChange={event => {
                                            this.setState({
                                                name: event.target.value,
                                                nameError: ''
                                            });
                                        }}
                                        defaultValue={name}
                                        disabled={loaderButton ? true : false}
                                    />
                                </div>
                            </React.Fragment>
                        )}

                        <div className="col-md-6 col-xs-12">
                            <TextField
                                error={priceError ? true : false}
                                helperText={priceError}
                                type="text"
                                name="price"
                                label="Price"
                                id="price"
                                fullWidth
                                className="login-form-textfield"
                                placeholder="Add Price"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                margin="normal"
                                onChange={event => {
                                    this.setState({
                                        price: event.target.value,
                                        priceError: '',
                                        error: ''
                                    });
                                }}
                                defaultValue={price}
                                disabled={loaderButton ? true : false}
                            />
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <FormControl
                                className={
                                    classes.formControl +
                                    ' login-form-textfield  mt-15'
                                }
                                error={statusError ? true : false}
                            >
                                <InputLabel shrink>Status</InputLabel>
                                <Select
                                    className="login-form-textfield form-control"
                                    autoWidth={true}
                                    value={this.state.status}
                                    onChange={this.handleStatusChange}
                                    inputProps={{
                                        name: 'status'
                                    }}
                                >
                                    <MenuItem value={1}>Active</MenuItem>
                                    <MenuItem value={2}>Inactive</MenuItem>
                                </Select>
                                <FormHelperText>{statusError}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <TextField
                                error={descriptionError ? true : false}
                                helperText={descriptionError}
                                type="text"
                                name="description"
                                label="Description"
                                id="description"
                                className="login-form-textfield "
                                fullWidth
                                placeholder="Add Description"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                margin="normal"
                                onChange={event => {
                                    this.setState({
                                        description: event.target.value,
                                        descriptionError: '',
                                        error: ''
                                    });
                                }}
                                defaultValue={description}
                                disabled={loaderButton ? true : false}
                            />
                        </div>

                        <div className="col-md-12">
                            <MultiAddressPanel
                                addNewAddress={this.addNewAddress}
                                setBookingAddress={keys =>
                                    this.setAddress(keys)
                                }
                                selectedKeys={this.state.selectedAddresses}
                                {...this.props}
                            />
                            {addressError && (
                                <h6 style={{ color: 'red' }}>{addressError}</h6>
                            )}
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <div className="mt-3">{this.renderButton()}</div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const composedComponent = compose(withStyles(styles), connect(null, actions));
export default withCustomTheme(composedComponent(injectIntl(ServiceUpdate)));



// WEBPACK FOOTER //
// ./src/components/Providers/ServiceUpdate.js